export default __webpack_public_path__ + "static/media/v2.efaadb46.mp4";